import { render, staticRenderFns } from "./CombinedSortItems.vue?vue&type=template&id=13703fbf&scoped=true&"
import script from "./CombinedSortItems.vue?vue&type=script&lang=js&"
export * from "./CombinedSortItems.vue?vue&type=script&lang=js&"
import style0 from "./CombinedSortItems.vue?vue&type=style&index=0&id=13703fbf&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13703fbf",
  null
  
)

export default component.exports